import { createRouter, createWebHistory } from "vue-router";
import type { RouteRecordRaw } from "vue-router";
import type { App } from "vue";
const layout = () => import("@/layout/index.vue");
const route: RouteRecordRaw[] = [
  {
    path: "/",
    component: layout,
    name: "Dashboard",
    redirect: "/home",
    children: [
      {
        path: "/home",
        name: "home",
        component: () => import("@/views/home/index.vue"),
      },
      {
        path: "/business",
        name: "business",
        component: () => import("@/views/business/index.vue"),
      },
      {
        path: "/product",
        name: "product",
        component: () => import("@/views/product/index.vue"),
      },
      {
        path: "/news",
        name: "news",
        component: () => import("@/views/news/index.vue"),
      },
      {
        path: "/introduce",
        name: "introduce",
        component: () => import("@/views/about/introduce.vue"),
      },
      {
        path: "/infoView",
        name: "infoView",
        component: () => import("@/views/infoView/index.vue"),
      },
      {
        path: "/recruit",
        name: "recruit",
        component: () => import("@/views/about/recruit.vue"),
      },
      {
        path: "/partners",
        name: "partners",
        component: () => import("@/views/about/partners.vue"),
      },
      {
        path: "/contactUs",
        name: "contactUs",
        component: () => import("@/views/about/contactUs.vue"),
      },
      {
        path: "/coordoicking",
        name: "coordoicking",
        component: () => import("@/views/tool/coordoicking.vue"),
      },
    ],
  },
  {
    path: "/404",
    name: "404",
    component: () => import("@/views/error/404.vue"),
  },
];

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: route,
  // 刷新时，滚动条位置还原
  scrollBehavior() {
    return {
      left: 0,
      top: 0,
    };
  },
  // 重写滚动逻辑：返回页面保留滚动，新跳转置顶
  // scrollBehavior(to, from, savedPosition) {
  //   console.log(to, from, savedPosition);
    
  //   // savedPosition 仅在浏览器返回/前进时有值，代表上一页滚动位置
  //   if (savedPosition) {
  //     // 返回上一页：恢复原来滚动位置，不跳到顶部
  //     return savedPosition;
  //   } else {
  //     // 全新跳转页面：滚动到顶部
  //     return { left: 0, top: 0 };
  //   }
  // },
});

export const setupRouter = (app: App<Element>) => {
  app.use(router);
};

export default router;
